import { Component } from '@angular/core';
import { Claim } from '../../../generic/classes/claim';
import { Logger } from '../../../generic/logging/default-log.service';
import { ApplicationService } from '../../../generic/service/application.service';
import { ClaimService } from '../../../service/claim.service';
import { PaginationMethods, PaginationComponent } from '../../filters/pagination.component';
import { PaginationData } from '../../filters/pagination.data';
import { CustomDatePipe } from '../../../generic/pipes/custom.date.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { RenderClaimStatusComponent } from './render.claim.status';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'claim-overview',
    templateUrl: 'claim.overview.component.html',
    styleUrls: ['./claim.component.scss'],
    standalone: true,
    imports: [
        RouterLink,
        PaginationComponent,
        RenderClaimStatusComponent,
        NgxPaginationModule,
        CustomDatePipe,
    ],
})
export class ClaimOverviewComponent implements PaginationMethods {
    claims: Claim[] = null;
    noClaims: boolean = false;
    paginationData: PaginationData<Claim>;

    constructor(
        public applicationService: ApplicationService,
        private claimService: ClaimService,
        private logger: Logger,
    ) {
        this.getClaims(1);
    }

    goToPage(pageNum: number): void {
        this.getClaims(pageNum);
    }

    private getClaims(page: number) {
        this.claimService.getClaimsForUser(page).subscribe(
            claims => this.setClaim(claims),
            error => this.logger.error('Failed to get claims', error),
        );
    }

    private setClaim(pagination: PaginationData<Claim>): void {
        this.claims = pagination.content;
        this.noClaims = this.claims.length === 0;
        this.paginationData = pagination;
    }
}
